module.exports = __webpack_public_path__ + "img/D.e21cecc2.svg";